import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  getUserWarrantyClaims,
} from "../actions/orderActions";

export default function ClaimsList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const WarrantyClaimsList = useSelector((state) => state.WarrantyClaimsList);
  const { loading, error, claims } = WarrantyClaimsList;

  useEffect(() => {

    if (!userInfo) {
      navigate(`/signup`);
    } else {
      dispatch(getUserWarrantyClaims(false));
    }
  }, [dispatch]);

  return (
    <div className="flex flex-col gap-4 md:gap-8 p-6 bg-white">
      <div className="flex mx-auto">
        <p className="text-lg md:text-2xl font-bold underline underline-offset-8">
          My Claims
        </p>
      </div>

      {loading ? (
        <div>Loading</div>
      ) : error ? (
        <div>{error.message}</div>
      ) :
        claims.length === 0 ? (
          <div className="flex justify-center items-center h-48 text-gray-500 text-center w-full">
            No warranty claim products
          </div>
        ) :
          (
            <div className="flex flex-col">
              {claims.map((claim, index) => (
                <div
                  key={index}
                  className="flex flex-col w-full md:w-4/5 self-center border border-gray-300 rounded-md mb-4 md:mb-8"
                >
                  <div className="flex flex-wrap md:flex-nowrap justify-between items-center border-b border-gray-200 p-2 md:p-4">
                    <div className="flex flex-wrap md:flex-nowrap gap-4 md:gap-8">
                      <div>
                        <p className="font-semibold">Claim ID</p>
                        <p className="text-sm text-gray-500">{claim.claimId}</p>
                      </div>
                      <div>
                        <p className="font-semibold">Order Number</p>
                        <p className="text-sm text-gray-500">{claim.order?.order_id}</p>
                      </div>
                      <div>
                        <p className="font-semibold">Claim Date</p>
                        <p className="text-sm text-gray-500">
                          {dayjs(claim.createdAt).format("DD MMM YYYY, hh:mm A")}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-wrap md:flex-nowrap justify-between items-center border-b border-gray-200 p-2 md:p-4">
                    <div className="flex flex-wrap md:flex-nowrap gap-4 md:gap-8">
                      <div>
                        <p className="font-semibold">Product Name</p>
                        <p className="text-sm text-gray-500">{claim.productName || claim.product?.name}</p>
                      </div>
                      <div>
                        <p className="font-semibold">Product Amount</p>
                        <p className="text-sm text-gray-500">₹ {claim.claimAmount.toLocaleString("en-IN")}</p>
                      </div>
                    </div>
                  </div>


                  <div className="flex flex-col p-2 md:p-4 border-b border-gray-200">
                    <p className="font-semibold">Claim Message</p>
                    <p className="text-sm text-gray-500">{claim.claimMessage}</p>
                  </div>

                  <div className="flex flex-col p-2 md:p-4 border-b border-gray-200">
                    <p className="font-semibold">Product Images</p>
                    <div className="flex p-2 gap-4 md:p-4 justify-between md:gap-8">
                      {claim.photos?.map((img, idx) => (
                        <div className="w-1/5" key={idx}>
                          <img className="rounded-md" src={img} alt={img} loading="lazy" />
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex flex-wrap md:flex-nowrap justify-between items-center p-2 md:p-4">
                    <div className="flex flex-wrap md:flex-nowrap gap-4 md:gap-8">
                      <div>
                        <p className="font-semibold">Status</p>
                        <p className="text-sm text-gray-500">{claim.status}</p>
                      </div>
                      {claim.status !== "Pending" && (
                        <div>
                          <p className="font-semibold">{claim.status} Date</p>
                          <p className="text-sm text-gray-500">{dayjs(claim.updatedAt).format("DD MMM YYYY, hh:mm A")}</p>
                        </div>
                      )}
                      {claim.status !== "Pending" && (
                        <div>
                          <p className="font-semibold">{claim.status} Message</p>
                          <p className="text-sm text-gray-500">{claim.message}</p>
                        </div>
                      )}

                    </div>
                  </div>

                </div>
              ))}
            </div>
          )}
    </div>
  );
}
